import { CreditCardToken } from './payment-creditcard-token';
import { PayonCreditCardWidget } from './payment-creditcard-widget';
import { handleRedirection } from './payment-redirection';
import { CardSlider } from './card-slider';
import { isSecondaryBlockOpened } from './payment';
import { i18n } from '@/commons/utils';

export function CreditCardBlock() {

  this.init = function init(params) {
    const $this = this;

    this.container = params.container;
    this.parent = params.parent;
    this.onExpressConfirmation = params.onExpressConfirmation;

    this.props = {
      page: params.parent,
      canAddNewCard: params.canAddNewCard || false,
      isWallet: params.isWallet || false,
      isExpress: params.isExpress || false,
      isCheckout: params.isCheckout || false,
      orderId: params.orderId,
      multiEnabled: (this.container.getAttribute('data-multi-enabled') === 'true'),
      paymentTypeId: this.container.getAttribute('data-payment-type-id'),
      actionType: params.actionType || null,
      refundId: params.refundId || null,
      delayPrepareAuth: params.delayPrepareAuth || false
    };

    if (document.getElementById('orderTrackingUrl') !== null) {
      this.props.orderTracking = document.getElementById('orderTrackingUrl').value;
    }

    this.state = {
      selected: params.selected || false,
      hasError: false,
      isCvcTooltipVisible: false
    };

    this.sliderActions = this.container.querySelector('.dkt-card-slider-actions');
    this.cvcContainer = this.container.querySelector('.dkt-flipable .dkt-card-cvc-container');
    this.cvcButton = this.container.querySelector('.dkt-flipable .dkt-card-cvc-button');

    if (this.props.isCheckout === true) {
      this.header = this.container.querySelector('.dkt-block-header');
      this.content = this.container.querySelector('.dkt-block-content');
    }

    if (this.props.canAddNewCard === true) {
      this.retryButton = this.container.querySelector('.dkt-creditcard-problem-button');
    }

    if (this.props.canAddNewCard === false) {
      this.sliderActions.classList.add('dkt-card-slider-actions--hidden');
    }

    this.slider = new CardSlider();
    this.cards = this.container.querySelectorAll('.dkt-card-slider-item[data-is-favorite]');
    this.tokens = [...this.cards].map((card, index) => {
      const token = new CreditCardToken($this.slider);
      token.init({
        'container': card,
        'index': index,
        'isWallet': this.props.isWallet
      });
      return token;
    });

    if (params.orderId) {
      this.orderId = params.orderId;
    }

    if (this.props.canAddNewCard === true && this.props.delayPrepareAuth === false) {
      this.prepareAuth();
    }

    this.events();
    if (this.state.selected === true) {
      this.select();
    }
  };
}

CreditCardBlock.prototype.events = function events() {
  const bindedCheck = this.check.bind(this);
  const bindedCheckBrand = this.checkBrand.bind(this);
  const bindedUnselect = this.unselect.bind(this);
  const bindedSubmitNewCardPayment = this.submitNewCardPayment.bind(this);

  document.addEventListener('clickedOnPay', bindedCheck);
  document.addEventListener('payonReady', bindedCheckBrand);
  document.addEventListener('PrimaryPaymentBlockSelected', bindedUnselect);
  document.addEventListener('noPayonError', bindedSubmitNewCardPayment);

  document.addEventListener('closeExpress', () => {
    document.removeEventListener('clickedOnPay', bindedCheck);
    document.removeEventListener('payonReady', bindedCheckBrand);
    document.removeEventListener('PrimaryPaymentBlockSelected', bindedUnselect);
    document.removeEventListener('noPayonError', bindedSubmitNewCardPayment);
  });

  if (this.retryButton) {
    this.retryButton.addEventListener('click', this.prepareAuth.bind(this));
  }

  if (this.props.isCheckout === true) {
    this.header.addEventListener('click', this.select.bind(this));
  }

  if (this.cvcButton !== null) {
    this.cvcButton.addEventListener('click', this.displayCvcTooltip.bind(this));
  }
};

CreditCardBlock.prototype.onNewCardFormDisplayChanged = function onNewCardFormDisplayChanged(isDisplayed) {
  if (isDisplayed === true) {
    document.dispatchEvent(new CustomEvent('unSelectAllCreditCards'));
  } else {
    this.selectFavoriteToken();
  }
};

CreditCardBlock.prototype.prepareAuth = function prepareAuth() {
  if (this.state.selected && this.props.page.disableButton) {
    this.props.page.disableButton();
  }

  const $this = this;
  const widgets = document.querySelectorAll('.wpwl-container');
  [...widgets].forEach(widget => {
    widget.parentNode.removeChild(widget);
  });

  const params = {
    paymentTypeId: this.props.paymentTypeId,
    actionType: this.props.actionType,
    refundId: this.props.refundId,
    orderId: this.props.orderId
  };

  let url = 'prepareAuth';
  if (this.props.actionType === 'REFUND')
    url = 'prepareAuthForRefund';

  cube.ajax.post(`rest/model/com/decathlon/cube/commerce/payment/PaymentActor/${url}?orderId=${params.orderId}`, params)
    .onSuccess(this.prepareAuthSuccess.bind($this))
    .call();
};

CreditCardBlock.prototype.prepareAuthSuccess = function prepareAuthSuccess(response) {
  const $this = this;
  if (response.result && response.result.data.cardList !== '') {
    this.container.classList.remove('dkt-block--technical-problem');
    this.isPreAuthOk = true;

    const widget = this.container.querySelector('.dkt-payon_widget-container');
    if (widget !== null) {
      widget.parentNode.removeChild(widget);
    }
    this.loadJs(response.result.data.widgetUrl, () => {
      $this.props.cardListString = response.result.data.cardList;
      $this.props.cardList = response.result.data.cardList && response.result.data.cardList.split(' ');
      $this.updateLogos();

      if (response.result.data.cardListCannotBeSaved && response.result.data.cardListCannotBeSaved !== '')
        $this.props.cardListCannotBeSaved = response.result.data.cardListCannotBeSaved.split(' ');

      $this.creditCardWidget = new PayonCreditCardWidget($this);
      $this.container.querySelector('.dkt-card--verso').insertAdjacentHTML('afterbegin', $this.creditCardWidget.render());
    });
    if (this.state.selected && this.props.page.enableButton) {
      this.props.page.enableButton();
    }
  } else {
    if (response.error && response.error.message) {
      this.props.page.displayError(response.error.message);
    } else {
      this.props.page.displayError(response.responseTO.errors[0].message);
    }
    this.isPreAuthOk = false;
    this.container.classList.add('dkt-block--technical-problem');

    if (this.state.selected && this.props.page.disableButton) {
      this.props.page.disableButton();
    }
  }
};

CreditCardBlock.prototype.loadJs = function loadJs(src, callback) {
  const payonScript = cube.$id('payon-widget-script');
  if (payonScript !== null)
    payonScript.parentNode.removeChild(payonScript);

  const jsElm = document.createElement('script');

  jsElm.type = 'text/javascript';
  jsElm.src = src;
  jsElm.id = 'payon-widget-script';
  this.container.appendChild(jsElm);
  jsElm.onload = callback();
};

CreditCardBlock.prototype.submitTokenPayment = function submitTokenPayment(token) {
  const params = {
    orderId: this.props.orderId,
    paymentTypeId: this.props.paymentTypeId,
    tokenId: token.tokenId,
    cvc: token.cvc,
    redirectionUrl: document.getElementById('redirectionUrl').value
  };

  if (this.props.page.getAnalyticsInfos) {
    params.orderAttributes = JSON.stringify(this.props.page.getAnalyticsInfos());
  }

  params.useSecondaryMop = isSecondaryBlockOpened();

  if (this.props.page.displayLoader) {
    this.props.page.displayLoader();
  }

  cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
    .onSuccess(response => {
      if (response && response.result && response.result.data && response.result.data.redirectPspForm) {
        handleRedirection(this, response);
      } else {
        this.submitTokenPaymentSuccess(response);
      }
    })
    .call();
};

CreditCardBlock.prototype.submitTokenPaymentSuccess = function submitTokenPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const { data } = response.result;
    if (data !== false) {
      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.queue.send('proceedToConfirmation');
      }
      if (data.paymentModifiable === 'false') {
        window.location.reload();
      }

      if (data.redirectConfirmation === 'true') {
        window.location.href = data.redirectionUrl;
      }

      if (data.urlValidation) {
        window.location.href = data.urlValidation;
      }

      if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
        this.onExpressConfirmation(data.redirectConfirmation);
      }
    } else this.displayError(response.responseTO.errors[0].message);
  } else if (response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message) {
    this.displayError(response.responseTO.errors[0].message);
  } else {
    this.displayError('PAY_0001');
  }
};

CreditCardBlock.prototype.submitNewCardPayment = function submitNewCardPayment() {
  const params = {
    paymentTypeId: this.props.paymentTypeId,
    redirectionUrl: document.getElementById('redirectionUrl').value,
    orderTracking: this.orderTracking,
    orderId: this.props.orderId
  };

  if (this.props.page.getAnalyticsInfos) {
    params.orderAttributes = JSON.stringify(this.props.page.getAnalyticsInfos());
  }

  if (this.noSaveInWallet !== true) {
    params.saveInWallet = (document.getElementById('cb-save-credit-card') !== null && document.getElementById('cb-save-credit-card').checked);
  } else {
    params.saveInWallet = false;
  }

  params.useSecondaryMop = isSecondaryBlockOpened();

  if (this.props.page.displayLoader) {
    this.props.page.displayLoader();
  }

  let service = 'applyPayment';
  if (this.props.actionType === 'REFUND') {
    service = 'applyCredit';
    params.refundId = this.props.refundId;
    params.saveInWalletFromRefundProcess = (document.getElementById('cb-save-credit-card') !== null && document.getElementById('cb-save-credit-card').checked);
  }

  cube.ajax.post(`rest/model/com/decathlon/cube/commerce/payment/PaymentActor/${service}`, params)
    .onSuccess(this.submitNewCardPaymentSuccess.bind(this))
    .call();
};

CreditCardBlock.prototype.submitNewCardPaymentSuccess = function submitNewCardPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const { data } = response.result;
    if (data !== false) {
      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.queue.send('proceedToConfirmation');
      }
      if (data.widgetIntegration === 'true' || data.redirectConfirmation === 'true') {
        window.wpwlOptions.isReadyToSubmit = true;
        const widgetButton = this.container.querySelector('.wpwl-button-pay');
        widgetButton.removeAttribute('disabled');
        widgetButton.click();
      }

      if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
        this.onExpressConfirmation(data.redirectConfirmation);
      }
    } else
      this.displayError(response.responseTO.errors[0].message);
  } else
    this.displayError(response.responseTO.errors[0].message);
};

CreditCardBlock.prototype.updateLogos = function updateLogos() {
  const logosContainer = document.querySelector('.dkt-card-infos-logos');
  if (logosContainer) {
    logosContainer.innerHTML = '';
    [...this.props.cardList].forEach(brand => {
      const logo = document.createElement('li');
      logo.className = `dkt-card-infos-logo dkt-card-infos-logo--${brand}`;
      logo.innerHTML = `<img alt="${brand}" src="/assets/images/payment/cards/acceptance/${brand}-logo.png" />`;
      logosContainer.appendChild(logo);
    });
  }
};

CreditCardBlock.prototype.checkBrand = function checkBrand() {
  if (this.props.cardList && (this.props.cardList.indexOf('BCMC') !== -1 || this.props.cardList.indexOf('AMEX') !== -1 || this.props.cardList.indexOf('MAESTRO') !== -1)) {
    this.container.querySelector('.dkt-payon_widget-container').classList.add('dkt-payon_widget-container--brand-select');
  }
  if (this.props.cardListCannotBeSaved) {
    const saveCreditCard = document.querySelector('.js-save-credit-card');
    if (saveCreditCard) {
      const observer = new MutationObserver(event => {
        let brandMatched = false;
        [].forEach.call(this.props.cardListCannotBeSaved, brand => {
          if (brandMatched === false) {
            if (event[0].target.classList.contains(`wpwl-brand-${brand}`) === true) {
              saveCreditCard.classList.add('dkt-save-credit-card--hidden');
              brandMatched = true;
              this.noSaveInWallet = true;
            } else {
              saveCreditCard.classList.remove('dkt-save-credit-card--hidden');
              this.noSaveInWallet = false;
            }
          }
        });
      });

      observer.observe(document.querySelector('.wpwl-brand'), {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
      });
    }
  }
};

CreditCardBlock.prototype.check = function check() {
  if (this.state.selected === true) {
    if (this.props.page.checkTermsOfUse && this.props.page.checkTermsOfUse() === false) return;

    if (this.props.isCheckout) {
      if (this.props.page.checkBillingAddress && this.props.page.checkBillingAddress() === false) return;
      if (this.props.page.isFullSecondaryPayment && this.props.page.isFullSecondaryPayment() === true) return;
    }

    if (this.isTokenSelected() === true) {
      this.checkToken();
    } else {
      this.checkNewCard();
    }
  }
};

CreditCardBlock.prototype.checkToken = function checkToken() {
  const $this = this;
  this.tokens.forEach(token => {
    if (token.state.isSelected === true) {
      if (token.isOk() === true) {
        $this.submitTokenPayment(token);
      } else {
        $this.slider.current = $this.tokens.indexOf(token);
        $this.slider.displayCard(token);
      }
    }
  });
};

CreditCardBlock.prototype.checkNewCard = function checkNewCard() {
  if (this.isPreAuthOk !== true) {
    this.props.page.displayError(i18n('TECH_0001'));
    return;
  }

  const cardHolderInput = this.container.querySelector('.wpwl-control-cardHolder');
  const cardHolderWrapper = this.container.querySelector('.wpwl-wrapper-cardHolder');
  const cardHolder = cardHolderInput.value;
  const widgetButton = this.container.querySelector('.wpwl-button-pay');
  let hint = cardHolderWrapper.querySelector('.wpwl-hint');

  if (hint === null) {
    cardHolderWrapper.insertAdjacentHTML('beforeend', `<div class="wpwl-hint wpwl-hint--card-holder">${i18n('payment.primary.errorMessage.cardHolder')}</div>`);
    hint = cardHolderWrapper.querySelector('.wpwl-hint');
    this.slider.showNewCardForm();
  }

  if (cardHolder.trim().length <= 2) {
    cardHolderInput.classList.add('wpwl-has-error');
    if (hint !== null) {
      hint.style.display = 'block';
      this.slider.showNewCardForm();
    }
  } else {
    hint.style.display = 'none';
  }

  widgetButton.click();
};

CreditCardBlock.prototype.select = function select(event) {
  const $this = this;
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));

    $(this.content).slideDown('fast', () => {
      $this.container.classList.add('dkt-block--selected');
      $this.container.classList.add('dkt-block--open');
    });
    this.state.selected = true;
    this.slider.init({
      container: $this.container.querySelector('.dkt-card-slider-container'),
      parent: $this,
      displayNewCard: (this.tokens.length === 0)
    });

    if (this.props.isExpress === true || this.props.isCheckout === true) {
      this.selectFavoriteToken();
    }

    if (this.isPreAuthOk && this.props.page && this.props.page.enableButton) {
      this.props.page.enableButton();
    } else if (this.props.page && this.props.page.disableButton) {
      this.props.page.disableButton();
    }
  }
  if (this.props.delayPrepareAuth === true) {
    this.prepareAuth();
  }
};

CreditCardBlock.prototype.unselect = function unselect() {
  const $this = this;
  $(this.content).slideUp('normal', () => {
    $this.container.classList.remove('dkt-block--selected');
    $this.container.classList.remove('dkt-block--open');
  });
  this.state.selected = false;
};

CreditCardBlock.prototype.displayError = function displayError(message) {
  this.props.page.hideLoader();
  this.props.page.displayError(message);
};

CreditCardBlock.prototype.displayCvcTooltip = function displayCvcTooltip() {
  this.cvcContainer.classNameToggle('dkt-card-cvc-container--open', this.state.isCvcTooltipVisible === false);
  this.state.isCvcTooltipVisible = !this.state.isCvcTooltipVisible;
};

CreditCardBlock.prototype.selectFavoriteToken = function selectFavoriteToken() {
  if (this.isTokenFavorite() === true) {
    this.tokens.forEach(token => {
      if (token.state.isFavorite === true) {
        token.select();
        this.slider.current = this.tokens.indexOf(token);
        this.slider.changeCurrent();
      }
    });
  } else if (this.tokens.length > 0) {
    this.tokens[0].select();
    this.slider.current = 0;
    this.slider.changeCurrent();
  }
};

CreditCardBlock.prototype.isTokenSelected = function isTokenSelected() {
  const selectedToken = this.tokens.filter(token => token.state.isSelected === true);
  return (selectedToken.length >= 1);
};

CreditCardBlock.prototype.isTokenFavorite = function isTokenFavorite() {
  const favoriteToken = this.tokens.filter(token => token.state.isFavorite === true);
  return (favoriteToken.length >= 1);
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-creditcard.js